import config from '../config';

export default {
  inserted: function (el, binding, vnode) {
    const events = Object.keys(binding.modifiers);

    if (events.length === 0) {
      events.push('click');
    }

    events.forEach((event) => {
      el.addEventListener(event, function () {
        let fn = typeof binding.value === 'string' ? config.methods[binding.value] : binding.value;

        if (typeof fn === 'object') {
          fn = config.$vue.$analytics.event.bind(this, fn);
        }

        if (!fn) {
          throw new Error(
            '[vue-analytics] The value passed to v-analytics is not defined in the methods list.',
          );
        }

        fn.apply(vnode.context);
      });
    });
  },
};
